"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_2 = require("@fluentui/react");
require("./Pagination.scss");
var Pagination = function (props) {
    var currentPageIndex = props.currentPageIndex, totalPageCount = props.totalPageCount, nbPagesShown = props.nbPagesShown, itemsPerPage = props.itemsPerPage, onNavigate = props.onNavigate, labels = props.labels, totalRecordCount = props.totalRecordCount;
    var generatePageButtons = function () {
        var nbPages = nbPagesShown;
        if (totalPageCount <= 1) {
            return [];
        }
        if (nbPagesShown === 0) {
            nbPages = 1;
        }
        if (totalPageCount <= 1) {
            return [];
        }
        var firstPage = currentPageIndex - Math.trunc(nbPages / 2);
        if (firstPage < 0)
            firstPage = 0;
        var lastPage = firstPage + nbPages;
        if (lastPage > totalPageCount) {
            lastPage = totalPageCount;
            firstPage =
                lastPage - nbPages >= 0 ? lastPage - nbPages : firstPage;
        }
        var i = firstPage;
        var result = [];
        result.push({
            icon: 'DoubleChevronLeft',
            pageNum: -1,
            disabled: firstPage <= 0,
            action: { type: 'beginNav' },
        });
        result.push({
            icon: 'ChevronLeft',
            pageNum: currentPageIndex - 1,
            disabled: currentPageIndex === 0,
            action: { type: 'pageNav', pageNumber: currentPageIndex - 1 },
        });
        while (i < lastPage) {
            result.push({
                label: (i + 1).toString(),
                pageNum: i,
                disabled: false,
                action: { type: 'pageNav', pageNumber: i },
            });
            i += 1;
        }
        result.push({
            icon: 'ChevronRight',
            pageNum: currentPageIndex + 1,
            disabled: currentPageIndex === totalPageCount - 1,
            action: { type: 'pageNav', pageNumber: currentPageIndex + 1 },
        });
        result.push({
            icon: 'DoubleChevronRight',
            pageNum: totalPageCount + 1,
            disabled: lastPage >= totalPageCount,
            action: { type: 'endNav' },
        });
        return result;
    };
    return (react_1.default.createElement("div", { className: "eta-pagination", dir: "ltr" },
        react_1.default.createElement("div", { className: "eta-pagination-totalrecordCount" }, labels.totalRecord && totalRecordCount && (react_1.default.createElement(react_2.Label, { className: "eta-pagination-totalrecordCount-label" },
            labels.totalRecord,
            " ",
            totalRecordCount))),
        react_1.default.createElement("div", { className: "eta-pagination-pageselector" }, generatePageButtons().map(function (pageButton) {
            var _a;
            return (react_1.default.createElement(react_2.ActionButton, { key: (_a = pageButton.label) !== null && _a !== void 0 ? _a : pageButton.icon, allowDisabledFocus: true, onClick: function () {
                    onNavigate(pageButton.action);
                }, className: pageButton.label ? 'eta-pageNumber' : '', disabled: pageButton.disabled, iconProps: { iconName: pageButton.icon }, checked: pageButton.pageNum === currentPageIndex }, pageButton.label));
        })),
        labels.resultPerPage && (react_1.default.createElement("div", { className: "eta-pagination-itemperpage" },
            react_1.default.createElement(react_2.Label, { className: "eta-pagination-itemperpage-label" }, labels.resultPerPage),
            react_1.default.createElement(react_2.Dropdown, { selectedKey: itemsPerPage, options: [
                    { key: 10, text: '10' },
                    { key: 20, text: '20' },
                    { key: 50, text: '50' },
                    { key: 100, text: '100' },
                ], onChange: function (_, option) {
                    if (option) {
                        var numberOfItemPerPage = typeof option.key === 'string'
                            ? parseInt(option.key, 10)
                            : option.key;
                        onNavigate({
                            type: 'itemsPerPageNumberChanged',
                            numberOfItemPerPage: numberOfItemPerPage,
                        });
                    }
                } })))));
};
exports.default = Pagination;
//# sourceMappingURL=Pagination.js.map